import * as React from 'react';
import { Text, RichText, Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import "./index.scss";
import { bindPropsToComponentFields } from '../../utils/dochubUtils';

const ContentBlockModule = (props) => {
  if(props?.paramsFields) {
    bindPropsToComponentFields(props, props?.paramsFields);
  };

  const data = props.dataFromParent != null ? props.dataFromParent : props;
  const themeOption = data?.params?.Theme;
  const hasDescription = data?.fields?.["Strong Subtitle"]?.value != '' || data?.fields?.["Description"]?.value != '';
  const tagTitle = data?.fields?.["Tag Title"]?.value;
  const strongTitle = data?.fields?.["Strong Title"]?.value;
  const marginTop = props?.params?.TopMargin ? ` margin-top__${props?.params?.TopMargin} ` : "";
  const marginBottom = props?.params?.BottomMargin ? ` margin-bottom__${props?.params?.BottomMargin} ` : "";

  return (
    <>
      <section className={"content-block " + themeOption + marginTop + marginBottom} id={data?.rendering?.uid}>
        {hasDescription ?
          <div className={`content-main container`}>
            <Text
              field={props?.fields?.["Title"]}
              tag={tagTitle ? tagTitle : "h1"}
              style={strongTitle === true ? { fontWeight: "bold" } : { fontWeight: "300" }}
              className="title"
            />
            <div className={`content-items ${hasDescription ? "has-description" : ""}`}>
              <RichText
                field={props?.fields?.["Strong Subtitle"]}
                tag='p'
                className="strong-text BodyShort BodyShort.Strong"
              />
              <RichText
                field={props?.fields?.["Description"]}
                tag='p'
                className="BodyShort"
              />
              <Placeholder name="jss-button" rendering={props.rendering} />
            </div>
          </div>
          :
          <div className="content-main container">
            <div className="no-description">
              <Text
                field={props?.fields?.["Title"]}
                tag={tagTitle ? tagTitle : "h1"}
                style={strongTitle === true ? { fontWeight: "bold" } : { fontWeight: "300" }}
              />
              <Placeholder name="jss-button" rendering={props.rendering} />
            </div>
          </div>
        }
      </section>
    </>
  )
};

export default withSitecoreContext()(ContentBlockModule);